// src/games/Puckle.tsx
import React, { useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import { logEvent } from '../analytics';

const Puckle = () => {
    useEffect(() => {
        document.title = "Jets '14 | Puckle";
    }, []);

    const handleGameEvent = useCallback((event: MessageEvent) => {
        // Basic security check
        if (event.origin !== window.location.origin) {
            return;
        }
        const { type, payload } = event.data;
        if (type === 'puckle_event' && payload?.eventName) {
            logEvent(payload.eventName, payload.eventParams);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('message', handleGameEvent);
        return () => window.removeEventListener('message', handleGameEvent);
    }, [handleGameEvent]);

    return (
        // Updated height to 100vh to fill the entire screen
        <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            <iframe
                src="/games/puckle.html"
                title="Puckle Game"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </Box>
    );
};

export default Puckle;
